// extracted by mini-css-extract-plugin
export var removeAction = "RemoveAction-module--removeAction--57461";